import { AUTH_URL } from "../constants";
import { AUTH_KEY } from "../context/authContext";
import { APIRequest, HTTPClient, RequestType } from "../services/http_client";
import LocalStorageService from "../services/localstorage.service";
import { AdAnalyticsType } from "../types/ad.analytics";

const client = new HTTPClient()

export interface ResponseType {
    data?: AdAnalyticsType;
    error?: string;
}

class AdAnalyticsModel {
    static find = async ({groupId, position, filter}: {groupId: number, position: string, filter: string}): Promise<ResponseType> => {
        const auth = LocalStorageService.get(AUTH_KEY)
        if(!auth) return {
            error: "Unauthorized"
        }

        const request = new APIRequest(
            RequestType.GET,
           `${AUTH_URL}/ads/${groupId}/${position}/${filter}/analytics`,
            undefined,
            auth.accessToken,
        );

        const response = await client.get(request);

        if (!response.success) {
            return {
                error: response.errorMessage,
            }
        }
  
        return {
            data: response.result as unknown as AdAnalyticsType
        }
    };
}

export default AdAnalyticsModel